import CandidateListing from "./views/pages/CandidateListing/CandidateListing";
import Image from "./views/pages/DocumentPreview/Image";
import Keywords from "./views/pages/DocumentPreview/Keywords";
import CandidateDetail from "./views/pages/DocumentPreview/CandidateDetail";
import Button from "./views/pages/Button/Button";

const routes = [
  {
    path: "/button",
    name: "Button",
    element: Button,
    roles: ["superadmin", "scrutiny"],
  },
  {
    path: "/candidate-listing",
    name: "Candidate Listing",
    element: CandidateListing,
    roles: ["superadmin", "scrutiny"],
  },
  {
    path: "/candidate-detail",
    name: "Candidate Detail",
    element: CandidateDetail,
    roles: ["superadmin", "scrutiny"],
  },
  {
    path: "/image-preview",
    name: "Image Preview",
    element: Image,
    roles: ["superadmin", "scrutiny"],
  },
  {
    path: "/keywords",
    name: "Keywords",
    element: Keywords,
    roles: ["superadmin", "scrutiny"],
  },
];

export default routes;
